var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.$style.logos}},[_c('MirLogo'),_c('SbpLogo'),_c('VisaLogo'),_c('MastercardLogo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }